/* eslint-disable react/prop-types */
import CloudinaryVideo from './oc-cloudinary-video';
import Image from './oc-image';
import Link from './oc-link';
import Picture from './oc-picture';
import Video from './oc-video';

const isCloudinaryVideo = video =>
  video.indexOf('cloudinary') !== -1 || video.indexOf('imagecdn.owenscorning.com') !== -1;

const ImageComponent = ({ alt, className, img, transform, variants }) => {
  if (transform || variants) {
    return <Picture source={img} alt={alt} transform={transform} variants={variants} className={className} />;
  }
  return <Image src={img} alt={alt} className={className} />;
};

const Media = ({ img, imageUrl, transform, variants, alt, video, className }) => {
  if (video) {
    if (isCloudinaryVideo(video)) return <CloudinaryVideo src={video} className={className} />;
    return <Video src={video} className={className} />;
  }

  if (imageUrl) {
    return (
      <Link href={imageUrl} target="_blank">
        <ImageComponent alt={alt} className={className} img={img} transform={transform} variants={variants} />
      </Link>
    );
  }

  return <ImageComponent alt={alt} className={className} img={img} transform={transform} variants={variants} />;
};

export default Media;
